import React from 'react';
import moment from 'moment';

import './ForumItem.scss';

import { Loader } from '../../';
import doctorsImgs from '../../../assets/img/llc/doctors/';

class ForumItem extends React.PureComponent {
  formatTime = (time) => {
    return moment(time).format("D.M.YYYY HH:mm");
  };

  renderThreads = () => {
    const doctors = this.props.langs.doctors;
    const filteredThreads = this.props.threads.filter(thread => thread.answer.trim().length > 0);
    return filteredThreads.map(thread => {

      let doctor = null;

      if (thread.answer.trim().length > 0) {
        doctor = doctors.find(doc => parseInt(doc.id) === parseInt(thread.support_id))
      }

      if (thread.answer.length > 0 && parseInt(thread.support_id) === 31) doctor = {name: "Klinika LLC Ostrava"};
      if (thread.answer.length > 0 && parseInt(thread.support_id) === 32) doctor = {name: "Klinika LLC Olomouc"};
      if (thread.answer.length > 0 && parseInt(thread.support_id) === 33) doctor = {name: "Klinika LLC Opava"};

      return (
        <div className="forumItem" key={thread.id}>
          <div className="forumItem_container">
            <div className="forumItem_title">{thread.procedure.name}</div>
            <div className="forumItem_question">
              <div className="forumItem_question_top">
                <div className="forumItem_question_name">{thread.name}</div>
                {/* <div className="forumItem_time">{this.formatTime(thread.created_at)}</div> */}
              </div>
              <div className="forumItem_text">
                {thread.text}
              </div>
            </div>
            {doctor &&
            <div className="forumItem_reply">
              <div className="forumItem_reply_top">
                <div className="forumItem_reply_top_user">
                  {doctor.photoId &&
                  <div className="forumItem_reply_top_user_img">
                    <img src={doctorsImgs[doctor.photoId]}/>
                  </div>
                  }
                  <div className="forumItem_reply_top_user_text">
                    Odpovídá: <br/> <strong>{doctor.name}</strong>
                  </div>
                </div>
                <div className="forumItem_time">{this.formatTime(thread.answered_at)}</div>
              </div>
              <div className="forumItem_text forumItem_reply_text">
                {thread.answer}
              </div>
            </div>
            }
          </div>
        </div>
      )
    })
  };

  render() {
    return (
      <section className="forumItem_wrapper">
        {this.renderThreads()}
        {this.props.loading && <div className="text-center m-t-50"><Loader/></div>}
      </section>
    );
  }
}

export default ForumItem;



// WEBPACK FOOTER //
// ./src/components/Forum/ForumItem/ForumItem.js